import EventBus from '@/event-bus';
import _Singleton from '@/tools/singleton';

import options from '@/ui/ui_ajax-filter/default-selectors.json';
import defaultSettings from '@/ui/ui_ajax-filter/default-settings.json';
import * as HumanReadableUrls from '@/ui/ui_human-urls';
import * as HumanReadableUrlsHandlers from '@/ui/ui_human-urls/handlers';

/**
 * @class
 * @private
 *
 * @description
 * DOM + AjaxFilter
 */
var AjaxFilterDOM = function() {
  var self = this;

  document.addEventListener('DOMContentLoaded', function() {
    self._init();
  });
};

/**
 * Обновление
 * @method
 * @private
 */
AjaxFilterDOM.prototype.update = function() {
  var self = this;
  const filterNodes = document.querySelectorAll(self.options.ajaxFilter.attr);

  if (filterNodes.length == 0) {
    return;
  }

  self._setMaxFilterItems(filterNodes[0]);
  self._setSubscribeForLoadingItems();

  self.filterNodes = filterNodes;
  self._renderFilter();
};

/**
 * Инициализация
 * @method
 * @private
 */
AjaxFilterDOM.prototype._init = function() {
  var self = this;

  self.options = options;
  self.defaultSettings = defaultSettings;

  const filterNodes = document.querySelectorAll(self.options.ajaxFilter.attr);

  if (filterNodes.length == 0) {
    return;
  }
  self.filterNodes = filterNodes;
  self.json = null;

  self._setMaxFilterItems(filterNodes[0]);
  self._setSubscribeForLoadingItems();

  (async () => {
    await self._getFilterData()
    .then((json) => {
      self.json = json;
      self._buildPermalinkMaps();
    });

    try {
      self._renderFilter();
    } catch (err) {
      console.error(err);
    }
  })();
};

/**
 * @private
 *
 * @description
 * Рендерим элемент из шаблона (template-а)
 */
AjaxFilterDOM.prototype._renderElement = function(filterNode, templateName) {
  const template = filterNode.querySelector(templateName);

  if (!template) {
    return false;
  }

  return template.content.cloneNode(true);
};

/**
 * @private
 *
 * @description
 * Подготавливаем вспомогательные мапы id → permalink для свойств/характеристик и options
 */
AjaxFilterDOM.prototype._buildPermalinkMaps = function() {
  if (HumanReadableUrlsHandlers.isHumanReadableEnabled()) {
    this._permalinkMaps = HumanReadableUrls.buildPermalinkMaps(this.json);
  }
};

AjaxFilterDOM.prototype.getCurrentState = function() {
  if (HumanReadableUrlsHandlers.isHumanReadableEnabled()) {
    return HumanReadableUrls.getCurrentState(this.json);
  }
  return {};
};

AjaxFilterDOM.prototype.buildHumanReadableUrl = function(state) {
  if (!HumanReadableUrlsHandlers.isHumanReadableEnabled()) {
    return null;
  }
  const currentState = state || this.getCurrentState();
  const permalinkMaps = this._permalinkMaps || HumanReadableUrls.buildPermalinkMaps(this.json);
  return HumanReadableUrls.buildHumanReadableUrl(currentState, permalinkMaps, this.json);
};

/**
 * @private
 *
 * @description
 * Рендер хар-ик и свойств
 */
AjaxFilterDOM.prototype._renderProperties = function(filterNode, curCharact = 'options') {
  var self = this;
  const fragment = document.createDocumentFragment();

  if (curCharact == 'properties') {
    self.json.properties.forEach(prop => {
      const isNumeric = prop['is_numeric?'] && prop.characteristics.length > 1;
      const property = self._renderProperty(filterNode, prop, isNumeric, 'property');

      if (!property) {
        return;
      }
      fragment.appendChild(property);
    });
  } else {
    self.json.options.forEach(opt => {
      const isNumeric = false;
      const option = self._renderProperty(filterNode, opt, isNumeric);

      if (!option) {
        return;
      }
      fragment.appendChild(option);
    });
  }

  return fragment;
};

/**
 * @private
 * @param forceRenderBtns[Boolean] принудительная отрисовка кнопок показать/спрятать все
 * @description
 * Рендер списка хар-ик и свойств
 */
AjaxFilterDOM.prototype._renderProperty = function(filterNode, prop, isNumeric, curCharact = 'option', forceRenderBtns = false) {
  var self = this;
  const template = self._renderElement(filterNode, self.options.ajaxFilterTemplateItem.attr);
  const el = template.querySelector(self.options.ajaxFilterItem.attr);
  const list = el.querySelector(self.options.ajaxFilterItemContent.attr);
  let propertyItemsSize = self.maxFilterItems;
  let isAllLoaded = true;

  el.querySelector(self.options.ajaxFilterItemTitle.attr).innerHTML = prop.title;
  el.querySelector(self.options.ajaxFilterItemTitle.attr).title = prop.title;

  if (curCharact == 'property') {
    el.classList.add(self.defaultSettings.classes.isProperty);

    if (isNumeric) {
      const parentElem = list.parentNode;

      parentElem.replaceChild(self._renderPropertyNumeric(filterNode, prop), list);
    } else {
      prop.characteristics.forEach((char) => {
        list.appendChild(self._renderPropertyUsual(filterNode, char, prop, false, false));
      });
    }

    propertyItemsSize = prop.characteristics_size ? prop.characteristics_size : propertyItemsSize;
    isAllLoaded = !prop.characteristics_size || prop.characteristics && prop.characteristics.length === prop.characteristics_size;
  } else {
    el.classList.add(self.defaultSettings.classes.isOption);

    // Проверяем есть ли в св-вах картинки
    let hasValueImg = false;
    const imageColorClass = self.defaultSettings.classes.imageColor;

    hasValueImg = prop.values.findIndex(item => item.image_url != null) != -1;

    if (self._isUseImages(filterNode) && hasValueImg) {
      list.classList.add(imageColorClass);
    } else {
      list.classList.remove(imageColorClass);
    }

    propertyItemsSize = prop.values_size ? prop.values_size : propertyItemsSize;
    isAllLoaded = !prop.values_size || prop.values && prop.values.length === prop.values_size;

    prop.values.forEach((value) => {
      const item = self._renderPropertyUsual(filterNode, value, prop, true, hasValueImg);

      list.appendChild(item);
    });
  }

  // отрисовываем кнопки если не все значения фильтра подгружены или какая-то часть значений скрыта
  if (self.maxFilterItems === 0) {
    if ((forceRenderBtns || propertyItemsSize > self.visibleItemsSize) && list.parentNode) {
      const btnsFragment = self._renderElement(filterNode, self.options.ajaxFilterTemplateItemViewAllBtns.attr);

      list.parentNode.appendChild(btnsFragment);
    }
  } else if ((forceRenderBtns || propertyItemsSize > self.maxFilterItems - self.visibleItemsSize) && list.parentNode) {
    const btnsFragment = self._renderElement(filterNode, self.options.ajaxFilterTemplateItemViewAllBtns.attr);

    list.parentNode.appendChild(btnsFragment);
  }

  // этот флаг устанавливается в true если все значения фильтра загружен иначе false
  el.setAttribute(self.defaultSettings.attributes.loaded, isAllLoaded);
  // прописываем id параметра или свойств, для последующей загрузки значений
  el.setAttribute(self.defaultSettings.attributes.propertyId, prop.id);
  // тип фильтра параметры или свойства property | option
  el.setAttribute('name', curCharact);

  if (!forceRenderBtns) {
    self._setShortListClasses(list);
  }

  return template;
};

/**
 * @private
 *
 * @description
 * Рендер одной опции характеристики / свойства (не числовой)
 */
AjaxFilterDOM.prototype._renderPropertyUsual = function(filterNode, char, prop, option = false, renderImage) {
  var self = this;

  const useImages = self._isUseImages(filterNode);
  const isUsualOption = (!renderImage && !useImages) || (renderImage && !useImages) || (!renderImage && useImages);

  let el = self._renderElement(filterNode, isUsualOption ? self.options.ajaxFilterTemplateUsual.attr : self.options.ajaxFilterTemplateColor.attr);
  const checkbox = el.querySelector('input');

  checkbox.id = `filter-value-${ char.id }`;
  checkbox.value = char.id;
  checkbox.name = option ? `options[${prop.id}][]` : 'characteristics[]';

  const label = el.querySelector(self.options.ajaxFilterOptionLabel.attr);
  const products_count = el.querySelector(self.options.ajaxFilterOptionProductsCount.attr);

  if (products_count) {
    products_count.innerHTML = char.products_count;
  }

  if (label) {
    label.innerHTML = char.title;
  }

  if (isUsualOption) {
    checkbox.checked = char['current?'] || char.selected;

    const label = el.querySelector(self.options.ajaxFilterOptionLabel.attr);
    const products_count = el.querySelector(self.options.ajaxFilterOptionProductsCount.attr);

    if (products_count) {
      products_count.innerHTML = char.products_count;
    }

    label.innerHTML = char.title;
  } else {
    const imageContainer = el.querySelector(self.options.ajaxFilterOptionImage.attr);

    imageContainer.title = char.title;
    checkbox.checked = char['current?'] || char.selected;

    if (char.image_url) {
      imageContainer.innerHTML = `<img src="${char.image_url}" />`;
    } else {
      imageContainer.innerHTML = '<span class="icon icon-times"></span>';
    }
  }

  // добавляем класс для контейнера выбранного значения фильтра
  if (el.firstElementChild) {
    el.firstElementChild.classList.toggle(self.defaultSettings.classes.filterItemChecked, checkbox.checked);
  }

  return el;
};

/**
 * @private
 *
 * @description
 * Рендер цены
 */
AjaxFilterDOM.prototype._renderPrice = function(filterNode) {
  var self = this;
  const el = self._renderElement(filterNode, self.options.ajaxFilterTemplatePrice.attr);

  if (!el) {
    return false;
  }

  const min = Math.round(self.json.products_price_min);
  const max = Math.round(self.json.products_price_max);
  const curMin = Math.round(self.json.current_price_min);
  const curMax = Math.round(self.json.current_price_max);

  const inputSlider = el.querySelector(self.options.ajaxFilterRange.attr);
  const inputMin = el.querySelector(self.options.ajaxFilterRangeFieldMin.attr);
  const inputMax = el.querySelector(self.options.ajaxFilterRangeFieldMax.attr);

  const sliderOptions = inputSlider.dataset.ajaxFilterRange;
  let step = 1;

  if (sliderOptions) {
    const customStep = JSON.parse(sliderOptions).step;

    if (customStep) {
      step = Math.round(customStep);
    }
  }

  const values = {
    min: min,
    max: max,
    from: curMin,
    to: curMax,
    step: step
  };

  self._createDataForRangeSlider(inputSlider, values);
  inputMin.value = values.from;
  inputMax.value = values.to;

  return el;
};

/**
 * @private
 *
 * @description
 * Рендер цифрового параметра
 */
AjaxFilterDOM.prototype._renderPropertyNumeric = function(filterNode, prop) {
  var self = this;
  const el = self._renderElement(filterNode, self.options.ajaxFilterTemplateNumeric.attr);
  const chars = prop.characteristics.map(char => parseFloat(char.title));

  const min = Math.min(...chars);
  const max = Math.max(...chars);
  const from = prop.gt_value || min;
  const to = prop.lt_value || max;
  let step = 1;

  const inputMin = el.querySelector(self.options.ajaxFilterRangeFieldMin.attr);
  const inputMax = el.querySelector(self.options.ajaxFilterRangeFieldMax.attr);

  if (min > 0 && min < 1) {
    step = min;
  }

  const values = {
    min: min,
    max: max,
    from: from,
    to: to,
    step: step
  };

  const inputSlider = el.querySelector(self.options.ajaxFilterRange.attr);

  self._createDataForRangeSlider(inputSlider, values);

  inputMin.name = `properties_gt[${ prop.id }]`;
  inputMin.value = from;
  inputMin.disabled = from == min;

  inputMax.name = `properties_lt[${ prop.id }]`;
  inputMax.value = to;
  inputMin.disabled = to == max;

  return el;
};

/**
 * @private
 *
 * @description
 * Установка данных для RangeSlider
 */
AjaxFilterDOM.prototype._createDataForRangeSlider = function(inputSlider, values) {
  inputSlider.dataset.rangeMin = values.min;
  inputSlider.dataset.rangeMax = values.max;
  inputSlider.dataset.rangeStart = values.from;
  inputSlider.dataset.rangeEnd = values.to;
  inputSlider.dataset.rangeStep = values.step || 1;
};

/**
 * @private
 *
 * @description
 * Рендер фильтра
 */
AjaxFilterDOM.prototype._renderFilter = function() {
  var self = this;

  if (self.json.status !== 'ok') {
    throw new Error('Failed to execute query');
  }

  const noInitFilters = Array.from(self.filterNodes).filter((item) => {
    return !item.classList.contains(self.defaultSettings.classes.ajaxFilterIsInit);
  });

  noInitFilters.forEach((filterNode) => {
    const fragments = {};
    const priceBlock = self._renderPrice(filterNode);

    if (priceBlock) {
      fragments.price = priceBlock;
    }

    if (self.json.options.length) {
      fragments.options = self._renderProperties(filterNode);
    }

    if (self.json.properties.length) {
      fragments.properties = self._renderProperties(filterNode, 'properties');
    }

    let fragment = document.createDocumentFragment();

    Object.values(fragments).forEach(frItem => {
      fragment.appendChild(frItem);
    });

    const filterItemsNode = filterNode.querySelector(self.options.ajaxFilterItems.attr);

    if (filterItemsNode) {
      filterItemsNode.append(fragment);
      self._addClickEventListener(filterNode, filterItemsNode);
      filterNode.classList.add(self.defaultSettings.classes.ajaxFilterIsInit);
      EventBus.publish('init-filter:ui-ajax-filter', { filterNode: filterNode });

      if (HumanReadableUrlsHandlers.isHumanReadableEnabled()) {
        HumanReadableUrlsHandlers.setupFilterWidgetHandlers();
      }
    }
  });
};

/**
 * @private
 *
 * @description
 * Переписывает части состояния фильтра по фактическому состоянию DOM‑формы
 */
AjaxFilterDOM.prototype._applyDomStateToState = function(formNode, state) {
  if (HumanReadableUrlsHandlers.isHumanReadableEnabled()) {
    HumanReadableUrls.applyDomStateToState(formNode, state);
  }
};

/**
 * @private
 *
 * @description
 * Подписываемся на "click" событие на всем фильтре
 */
AjaxFilterDOM.prototype._addClickEventListener = function(filterNode, filterItemsNode) {
  const self = this;

  filterItemsNode.addEventListener('click', (event) => {
    let filterItemEl = event.target.closest(self.options.ajaxFilterItem.attr);

    // обработчик событий click кнопки "Посмотреть все"
    if (event.target.hasAttribute(self.options.ajaxFilterViewAllBtn.value) == true) {
      event.preventDefault();
      self._handleViewAllBtnClick(event, filterNode);

      if (filterItemEl.hasAttribute(self.defaultSettings.attributes.loaded) && filterItemEl.getAttribute(self.defaultSettings.attributes.loaded) === 'false') {
        self._setFilterItemsLoadingStatus(filterItemEl);
      }

    // обработчик событий click кнопки "Спрятать все"
    } else if (event.target.hasAttribute(self.options.ajaxFilterHideAllBtn.value) == true) {
      event.preventDefault();
      filterItemEl.classList.remove(self.defaultSettings.classes.filterItemsExpanded);

      self._setShortListClasses(filterItemEl);
    }
  });
};

/**
 * @private
 *
 * @description
 * Обработчик на нажатие кнопки "Посмотреть все"
 */
AjaxFilterDOM.prototype._handleViewAllBtnClick = function(event, filterNode) {
  const self = this;
  const filterItemEl = event.target.closest(self.options.ajaxFilterItem.attr);
  filterItemEl.classList.add(self.defaultSettings.classes.filterItemsExpanded);

  let shortListItems = Array.from(filterItemEl.querySelectorAll(`.${self.defaultSettings.classes.filterShortListItem}`));

  // Находим айтемы с классом короткого списка и убираем его
  shortListItems.forEach(item => item.classList.remove(self.defaultSettings.classes.filterShortListItem));

  if (filterItemEl && filterItemEl.getAttribute(self.defaultSettings.attributes.loaded) == 'false') {
    event.stopImmediatePropagation();

    // собираем ищем все выбранные значения категории фильтра и создаем массив [[тип_значения, ID]]
    const checkedItems = [ ...event.target.parentElement.querySelectorAll("input[type='checkbox']:checked") ]
      .map((el) => [ el.name, el.value ]);

    // присваиваем параметр max_filter_items=0, если этого параметра не было задано
    const urlParams = new URLSearchParams(location.search);

    if (!urlParams.has('max_filter_items')) {
      urlParams.append('max_filter_items', '0');
    }

    const ajaxSearchString = urlParams.toString();

    // Получаем массив с handle категории и SEO-фильтра из адресной строки
    const handles = location.pathname.split('collection/').join('').split('/');

    // Получаем handle категории или категории с SEO-фильтром из массива handles и добавляем параметры
    const collection = handles[2] ? `${handles[1]}/${handles[2]}` : `${handles[1]}/items`;
    const collectionWithParams = ajaxSearchString ? `${collection}?${ajaxSearchString}` : collection;

    // добавляем ID категории фильтра для которого нужно подгрузить значения
    checkedItems.push([
      `${filterItemEl.getAttribute('name')}_ids`,
      filterItemEl.getAttribute(self.defaultSettings.attributes.propertyId)
    ]);

    let _json = {};

    // Формируем API путь в зависимости от того открыта ли страница SEO-фильтра
    let pathForAPI = '/front_api/fetch/';

    if (handles[2]) {
      pathForAPI = '/front_api/collection/';
    }

    self._getFilterData(`${pathForAPI}${collectionWithParams}`, checkedItems)
    .then((json) => {
      _json = json;

      try {
        const forceRenderBtns = true;
        let items = null;
        let itemType = null;

        // Определяем по чему идёт фильтрация: по свойству или по параметру товара из атрибута name, затем получаем данные из json
        const expectedFilterName = `${filterItemEl.getAttribute('name')}_ids`;
        const expectedFilter = checkedItems.find(item => item[0] === expectedFilterName);

        if (expectedFilter[0] === 'option_ids') {
          items = _json.options.find(option => option.id === parseInt(expectedFilter[1]));
          itemType = 'option';
        } else {
          items = _json.properties.find(prop => prop.id === parseInt(expectedFilter[1]));
          itemType = 'property';
        }

        const newFilterItemFragment = self._renderProperty(filterNode, items, false, itemType, forceRenderBtns);
        const filterItemElNew = newFilterItemFragment.querySelector(self.options.ajaxFilterItem.attr);

        filterItemEl.replaceWith(newFilterItemFragment);

        // после отрисовки фильтра кидаем событие, передаем новый дом элемент категории фильтра,
        // и заданные раннее классы стилей и выбранные значения фильтра
        EventBus.publish('filter-item-loaded:ui-ajax-filter', {
          filterItem: filterItemElNew,
          classList: [ ...filterItemEl.classList.values() ],
          checked: [ ...filterItemEl.querySelectorAll("input[type='checkbox']:checked") ].map(one => one.value)
        });
      } catch (err) {
        console.error(err);
      }
    });
  } else if (filterItemEl) {
    filterItemEl.classList.add(self.defaultSettings.classes.filterItemsExpanded);
  }
};

/**
 * @private
 *
 * @description
 * Получение данных
 */
AjaxFilterDOM.prototype._getFilterData = function(path, queryParams) {
  var self = this;

  if (location.pathname.indexOf('collection') === -1) {
    return;
  }

  return new Promise(async resolve => {
    const _path = !path ? '/front_api' + location.pathname + location.search : path;
    const url = new URL(location.origin + _path);

    // если не задан параметр max_filter_items принудительно его задаем
    if (self.maxFilterItems && url.searchParams.has('max_filter_items') === false) {
      url.searchParams.append('max_filter_items', self.maxFilterItems);
    }

    // добавляем параметры в запрос, предварительно убедившись что не создаем дубликатов
    if (queryParams && queryParams.length) {
      for (const [ key, value ] of queryParams) {
        if (url.searchParams.has(key) === true) {
          const values = url.searchParams.getAll(key);

          if (values.indexOf(value) === -1) {
            url.searchParams.append(key, value);
          }
        } else {
          url.searchParams.append(key, value);
        }
      }
    }

    const json = await fetch(url.href).then(response => response.json());

    resolve(json);
  });
};

/**
 * @private
 *
 * @description
 * Проверка на использование изображений для элемента фильтра (цвета)
 */
AjaxFilterDOM.prototype._isUseImages = function(filterNode) {
  let useImages = false;

  const filterParams = filterNode.dataset.ajaxFilter;

  if (filterParams) {
    const paramUseImages = JSON.parse(filterParams).useImages;

    if (paramUseImages) {
      useImages = paramUseImages == 'true';
    }
  }

  return useImages;
};

/**
 * @private
 *
 * @description
 * Получаем максимальное количество характеристик в свёрнутом списке
 */
AjaxFilterDOM.prototype._setMaxFilterItems = function(filterNode) {
  let self = this;
  let maxFilterItems;
  let visibleItemsSize;

  const filterParams = JSON.parse(filterNode.dataset.ajaxFilter);

  if (filterParams) {
    visibleItemsSize = filterParams.visibleItemsSize;
    let maxFilterItemsOption = filterParams.maxFilterItems;

    if (visibleItemsSize && isNaN(maxFilterItemsOption)) {
      maxFilterItems = visibleItemsSize * 2;
    } else if (!isNaN(maxFilterItemsOption)) {
      maxFilterItems = maxFilterItemsOption;
    } else {
      maxFilterItems = self.defaultSettings.maxFilterItems;
    }
  } else {
    visibleItemsSize = self.defaultSettings.visibleItemsSize;
    maxFilterItems = self.defaultSettings.maxFilterItems;
  }

  /* Разворачиваем все, если загрузили сразу все значения */
  if (maxFilterItems == 0) {
    self.visibleItemsSize = 1000;
  }
  else {
    self.visibleItemsSize = visibleItemsSize;
  }

  self.maxFilterItems = maxFilterItems;
};

/**
 * @private
 *
 * @description
 * Вешаем классы на элементы из короткого списка
 */
AjaxFilterDOM.prototype._setShortListClasses = function(filterNode) {
  let self = this;
  let listCheckedItems = Array.from(filterNode.querySelectorAll(`.${self.defaultSettings.classes.filterItemChecked}`));
  let listNotCheckedItems = Array.from(filterNode.querySelectorAll(`${self.options.ajaxFilterItemContentListItem.attr}:not(.${self.defaultSettings.classes.filterItemChecked})`));

  listCheckedItems.forEach(item => item.classList.add(self.defaultSettings.classes.filterShortListItem));

  for (let i = 0; i < (self.visibleItemsSize - listCheckedItems.length) && i < listNotCheckedItems.length; i++) {
    let item = listNotCheckedItems[i];

    if (i === self.visibleItemsSize) {
      break;
    }

    item.classList.add(self.defaultSettings.classes.filterShortListItem);
  }
};

/**
 * @private
 *
 * @description
 * Промежуточное состояние при отправке запроса для получения характеристик фильтра
 */
AjaxFilterDOM.prototype._setFilterItemsLoadingStatus = function(filterItemEl) {
  let self = this;

  // Вешаем disabled на кнопки "Показать всё", "Свернуть всё"
  filterItemEl.querySelector(self.options.ajaxFilterHideAllBtn.attr).setAttribute('disabled', 'disabled');

  // Вешаем класс со статусом загрузки
  filterItemEl.classList.add(self.defaultSettings.classes.filterItemsLoading);

  // Если есть шаблон прелоадера, то рендерим его и кладём в конец списка хар-ик
  let preloaderElement = self._renderElement(filterItemEl.closest(self.options.ajaxFilter.attr), self.options.ajaxFilterItemsTemplatePreloader.attr);
  if (preloaderElement) {
    filterItemEl.querySelector(self.options.ajaxFilterItemContent.attr).appendChild(preloaderElement);
  }
};

AjaxFilterDOM.prototype._setSubscribeForLoadingItems = function() {
  let self = this;
  EventBus.subscribe('filter-item-loaded:ui-ajax-filter', (item) => {
    let filterItem = item.filterItem;

    filterItem.querySelector(self.options.ajaxFilterHideAllBtn.attr).removeAttribute('disabled');
    filterItem.classList.remove(self.defaultSettings.classes.filterItemsLoading);
  });
};

export default _Singleton(AjaxFilterDOM).getInstance();
